/* eslint-disable react/no-multi-comp */
import React from 'react';
import { LocationInfoView } from './LocationInfoView';
import { connect } from 'react-redux';
import { withInsuranceTiers } from '../../Profile/gql/withInsuranceTiers';
import { mapDispatchToProps } from './mapDispatchToProps';

import { LocationCardView } from './LocationCardView';

const withInsuranceTierData = withInsuranceTiers(LocationInfoView);
const ConnectedLocationInfoView = connect(undefined, mapDispatchToProps)(withInsuranceTierData);


export {
    ConnectedLocationInfoView as LocationInfoView,
    LocationCardView,
};

export default class LocationCard extends React.PureComponent {
    render() {
        return (
            <div>
                {this.renderLocationCard()}
                {this.maybeRenderLocationInfo()}
            </div>
        );
    }

    renderLocationCard() {
        const {
            location,
            showingMore,
        } = this.props;

        return (
            <LocationCardView
                {...location}
                onClickExpandMap={this.handleClickExpandMap}
                onToggleShowMore={this.handleToggleShowMore}
                showingMore={showingMore}
            />
        );
    }

    maybeRenderLocationInfo() {
        const {
            location,
            providerId,
            showingMore,
        } = this.props;

        if (showingMore) {
            return (
                <ConnectedLocationInfoView
                    providerId={providerId}
                    {...location}
                />
            );
        }
    }

    handleToggleShowMore = ev => this.props.onToggleShowMore(ev, this.props.location);

    handleClickExpandMap = ev => this.props.onClickExpandMap(ev, this.props.location);
}
